import useSWR from "swr";

interface ValidateTokenResponse {
  valid: boolean;
  email?: string;
  suggestedUsername?: string;
  message?: string;
  code: number;
}

const validateToken = async (token: string): Promise<ValidateTokenResponse> => {
  const AUTH_URL = process.env.NEXT_PUBLIC_BACKEND_AUTH_URL || "";
  const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || "";

  const rawResponse = await fetch(
    `${AUTH_URL ?? BACKEND_URL}/activate/validate?token=${encodeURIComponent(token)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  );

  const response = await rawResponse.json();

  return {
    valid: response.valid ?? false,
    email: response.email,
    suggestedUsername: response.suggestedUsername,
    message: response.message,
    code: response.code,
  };
};

export const useValidateActivationToken = (token: string | null) => {
  return useSWR<ValidateTokenResponse>(
    token ? ["validateActivationToken", token] : null,
    () => (token ? validateToken(token) : Promise.reject("No token")),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }
  );
};
